'use client';
import React, { useEffect, useRef } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import PositioningSection from '@/components/PositioningSection';
import FeaturesSection from '@/components/FeaturesSection';
import HowItWorksSection from '@/components/HowItWorksSection';
import BenefitsSection from '@/components/BenefitsSection';
import WhyAgentOSDifferentSection from '@/components/WhyAgentOSDifferentSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import PricingSection from '@/components/PricingSection';
import FounderSection from '@/components/FounderSection';
import WhoItsForSection from '@/components/WhoItsForSection';
import FAQSection from '@/components/FAQSection';
import FinalCTASection from '@/components/FinalCTASection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observerRef?.current?.observe(el));

    return () => observerRef?.current?.disconnect();
  }, []);

  return (
    <main className="min-h-screen font-jakarta">
      <Navbar />
      <HeroSection />
      <PositioningSection />
      <HowItWorksSection />
      <FeaturesSection />
      <BenefitsSection />
      <WhyAgentOSDifferentSection />
      <TestimonialsSection />
      <PricingSection />
      <FounderSection />
      <WhoItsForSection />
      <FAQSection />
      <FinalCTASection />
      <ContactSection />
      <Footer />
    </main>
  );
}
